import Card from '@mui/material/Card'
import React from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { styled } from '@mui/material/styles';
import { useStateValue } from '../../../../Hooks/stateProvider'
import Styles from "../Styles/index.module.css";
import UploadAction from '../../../CommonLayouts/UploadAction'
import Swal from 'sweetalert2'
import { encrypt } from '../../../../utils/cipher'
import { ls } from '../../../../variables'
import { errorHandler } from '../../../../utils/errorHandling';
import { alert } from '../../../../utils/sweetAlert';


export const UploadFile = ({ setFormResult, setUploadFlag, setIsPreviewClicked, filePayload, type, fetchCurrentData }) => {
    
    const pmsName = ls.get("pmsName");
    const [{ fileDetails }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const email = ls.get("email");
    const userName = ls.get("userName");
    const fetchData = async () => {

        const formData = new FormData();
        formData.append("upload_file", fileDetails);

        let headers;
        if (type === "cmm") {
            headers = {
                'pmsName': pmsName,
                'fy_year': filePayload.fy_year,
                'quarter': filePayload.quarter,
                'filetype': 'CMM',
                'email': email,
                'username': userName
            }
        }

        headers['authtoken'] = ls.get("authToken")
        const encryptedHeaders = await encrypt(headers)


        
        setIsPreviewClicked(false);
        dispatch({ type: "SHOW_LOADER" });
        setUploadFlag(false)
        // console.log("payload", fy_year,quarter,half_year)
        // const encryptedHeaders = await encrypt(encryptedHeaders)

        axios
            .post('api/pms/fileUpload', formData, {
                headers: {
                    headers: encryptedHeaders
                }
            })
            .then((response) => {
                setIsPreviewClicked(true);
                if (response.data.success) {
                    fetchCurrentData()
                }
                else {
                    alert("Oops...", "Something went wrong!", "error")
                    dispatch({ type: "HIDE_LOADER" });
                }
            })
            .catch((err) => {
                dispatch({ type: "HIDE_LOADER" });
                console.log("error:", err)
                errorHandler(err, navigate)
            })

    }


    const downloadData = async () => {

        let payload;

        if (type === 'cmm') {
            payload = {
                'pmsName': pmsName,
                'fy_year': filePayload.fy_year,
                'quarter': filePayload.quarter,
                'moduleType': 'CMM',
            }
        } 

        payload['authToken'] = ls.get("authToken")
        payload['refreshToken'] = ls.get("refreshToken")

        const encryptedPayload = await encrypt(payload)

        axios.post('/api/pms/downloadFile', {
            payload: encryptedPayload
        }).then((response) => {
            if (response.data.success) {
                window.open(response.data.data, "_self");
            }

        })
            .catch((err) => {
                console.log("err:", err)
                errorHandler(err, navigate)
            })
    }

    return (

        <div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
                <Card sx={{ height: "99%", width: "100%", boxShadow: "#808080", background: "#EFEFF4", justifyContent: "space-evenly", display: "flex", flexDirection: "column", borderRadius: "10px" }} >
                    <div >
                        <div className={Styles.upload_functionality} style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "5%" }}>
                            <div>

                                <UploadAction type={type} />
                            </div>
                            <div style={{ marginTop : "2rem"}}>
                                {fileDetails == undefined && <span>Choose the required file to upload</span>}

                            </div>
                        </div>

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "5rem", gap: "1rem" }}>
                            <button style={{
                                backgroundColor: "#154063",
                                cursor: "pointer"
                            }}
                                className={Styles.FileUploadBtn} onClick={downloadData}>Download Template</button>
                            <button style={{
                                backgroundColor: fileDetails != undefined ? "#154063" : "#808080",
                                cursor: fileDetails != undefined ? "pointer" : "default",
                                border: fileDetails != undefined ? "0.125rem solid #154063" : "0.125rem solid #808080",
                            }}
                                disabled={fileDetails != undefined ? false : true} className={Styles.FileUploadBtn} onClick={fetchData}>Submit</button>

                            
                        </div>
                    </div>
                </Card>
        </div>
    )
}
